/**
 * Build-time gate for the route comparison behind the unified Swap (release 2026-09-28, §8:
 * environment config decides what is enabled in production). `NEXT_PUBLIC_MULTISWAP_ENABLED=false`
 * turns the CADINU-vs-PancakeSwap engine off: /swap is then the plain CADINU Smart Router swap, no
 * PancakeSwap quotes, no route details. Absent or any other value = enabled. Flipping it needs a
 * rebuild + restart (NEXT_PUBLIC_* is inlined at build time).
 */
export function isRouteCompareEnabled(value: string | undefined = process.env.NEXT_PUBLIC_MULTISWAP_ENABLED): boolean {
  return (value ?? '').trim().toLowerCase() !== 'false'
}

export const ROUTE_COMPARE_ENABLED = isRouteCompareEnabled()
